import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Employee } from 'src/app/data-analysis-summary/employee-information/employee-information.models';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from 'src/app/shared/constants/messages';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { role } from '../constants/role-enum';
import { ClientUsersService } from 'src/app/client-users/client-users.service';
@Component({
  selector: 'add-user-model',
  templateUrl: 'add-user-model.component.html',
  styleUrls: ['add-user-model.component.scss'],
})
export class AddUserModelComponent implements OnInit {
  targetForm: FormGroup;
  survey: any;
  surveyId: number;
  employees: Employee[];
  isInsert: boolean = true;
  Email: string;
  IsEmailExists: boolean = false;
  IsSignInNameExists: boolean = false;
  isContractor: boolean = false;
  emailPattern = /[a-zA-Z0-9_.+-,;]+@(?:(?:[a-zA-Z0-9-]+\.,;)?[a-zA-Z]+\.,;)?(kpmg|KPMG|Kpmg|kPmg|kpMg|kpmG|KPmg|KpMg|KpmG|kPMg|kPmG|kpMG|KPMg|kPMG|KPmG|KpMG)\.com/;
  @Output() modelStatusHandler: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isSearchKPMG: boolean;
  @Input() clientName: any;
  @Input() isSME: boolean;
  @Input() addUserName: string;
  @Output() user: EventEmitter<any> = new EventEmitter<any>();
  constructor(private _toastrService: ToastrService,
    private formBuilder: FormBuilder,
    public _clientUsersService: ClientUsersService) { }

  ngOnInit() {
    this.ResetFormData();
  }

  trimSpecialCharName(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-,'.()_/@ ]/g, ''),
    );
  }

  UpdateEmail(event: any) {
    this.targetForm.controls['email'].setValue(event.target.value);
  }

  ResetFormData() {
    this.targetForm = this.formBuilder.group({
      userId: [''],
      signinname: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],
      displayName: ['', Validators.required],
      clientName: ['', this.clientName ? Validators.required : null],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],

      IsContractor: ['', this.isContractor ? Validators.required : false],
    });
  }
  addUser() {
    let user: any = {
      clientName: this.targetForm.get('clientName').value,
      displayName: this.targetForm.get('displayName').value,
      signinname: this.targetForm.get('signinname').value,
      email: this.targetForm.get('email').value,
      IsContractor: this.isContractor,
      roleIds: null,
    };
    if (user.clientName === '') {
      user.roleIds = role.admin;
    }
    this._clientUsersService.CreateUserChampionAdmin(user).subscribe(
      data => {
        // If request is successful, Refresh data table on page
        // this._masterActivitiesService.refreshTable();
        if (data.success && data.result !== null) {
          this.user.emit(data.result);
          console.log(data);
          if (user.clientName === '') {
            this._toastrService.setSuccessMessage(
              Messages.Admin.User.AddUserSuccess,
            );
          } else {
            this._toastrService.setSuccessMessage(
              Messages.Admin.ClientUser.AddClientUserSuccess,
            );
          }
        }
      });
  }
  checkSigninName(ctrl: any) {
    let val = this.targetForm.get(ctrl).value;
    if (val && val.trim().length > 0) {
      this._clientUsersService.CheckSignInName(val).subscribe((data: any) => {
        if (data && data.result != null) {
          this.IsSignInNameExists = data.result;
        } else {
          this.IsSignInNameExists = false;
        }
      });
    } else {
      this.IsSignInNameExists = false;
    }
  }
  checkEmail() {
    if (this.Email != null) {
      this._clientUsersService.CheckEmail(this.Email).subscribe((data: any) => {
        if (data.result != null) {
          this.IsEmailExists = data.result;
        }
      });
    }
  }
  closeModel() {
    this.modelStatusHandler.emit(false);
  }
  get f() {
    return this.targetForm?.controls;
  }

  IsContractor = event => {
    if (event === true) {
      this.isContractor = event;
    } else {
      this.isContractor = false;
    }
  }
}
